import { PerspectiveCamera, Vector3 } from "three";
import { CameraConfig } from "./consts";
import { MathUtils } from "@utils/math";
class ThirdPersonCamera {
    camera;
    position;
    target;
    static instance;
    /**
     * ThirdPersonCamera is third-person camera with a perspective projection.
     * @param parent The group or scene that the camera is attached to.
     * @private
     */
    constructor(parent) {
        this.position = new Vector3().copy(CameraConfig.OFFSET_THIRD_PERSON);
        this.target = new Vector3().copy(CameraConfig.LOOKAT_THIRD_PERSON);
        this.camera = this.buildCamera();
        parent.add(this.camera);
    }
    /**
     * Update the camera's frustum based on the viewport.
     */
    updateResolution() {
        const { width, height } = this.getResolution();
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
    }
    /**
     * Create and configure a perspective camera object.
     * @returns The created camera object.
     * @private
     */
    buildCamera() {
        const { width, height } = this.getResolution();
        const camera = new PerspectiveCamera(CameraConfig.FOV, width / height, CameraConfig.NEAR, CameraConfig.FAR);
        camera.quaternion.copy(MathUtils.rotateAlongAxis(Math.PI / 2, new Vector3(0, 1, 0)));
        camera.position.copy(this.position);
        camera.lookAt(this.target);
        return camera;
    }
    /**
     * Get the screen resolution.
     * @returns the width and height of the viewport.
     * @private
     */
    getResolution() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }
    get getCamera() {
        return this.camera;
    }
    static getInstance(parent) {
        if (!ThirdPersonCamera.instance)
            ThirdPersonCamera.instance = new ThirdPersonCamera(parent);
        return ThirdPersonCamera.instance;
    }
}
export { ThirdPersonCamera };
